<template>
    <div class="add-rubric-and-students">
        <design-2021-rubric-survey-choose-skills-component :skill-trees-in="skillTreesIn"
                                                           :module-skill-trees-in="moduleSkillTreesIn"
                                                           ref="add-rubrics-component"
                                                           v-model="rubrics"
                                                           @input="update">
        </design-2021-rubric-survey-choose-skills-component>

        <design-2021-rubric-survey-rubrics-overview-component v-model="rubrics">
        </design-2021-rubric-survey-rubrics-overview-component>
    </div>
</template>


<script>
export default {
    name: "design-2021-rubric-survey-add-skills-component",
    props: {
        skillTreesIn: {
            type: Array,
            required: true,
        },
        moduleSkillTreesIn: {
            type: Array,
            required: false,
        },
        value:{
            type: [Array, Object],
        },
    },
    data() {
        return {
            rubrics: this.value ? this.value : [],
        }
    },

    methods: {
        setSkillTree(skillTree) {
            this.$refs['add-rubrics-component'].setSkillTree(skillTree);
        },
        update() {
            this.$emit('input', this.rubrics);
        },
    },

    watch: {
        rubrics: {
            'handler': function (val){
                this.rubrics = val;
            },
            deep: true,
        }
    }
}
</script>


<style scoped lang="scss">
    .add-rubric-and-students {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: flex-start;
        column-gap: $grid-gutter-width;
        row-gap: map-get($grid-gutter-spacing, 'fifteen');
    }

    .survey-choose-rubric,
    .survey-choose-student {
        flex: 1 1 100%;
    }

    .survey-overview {
        flex: 1 0 100%;
        margin-top: map-get($grid-gutter-spacing, 'forty-two');
    }

    @media(min-width: map-get($grid-breakpoints, 'lg')){
        .add-rubric-and-students {
            row-gap: 0;
        }

        .survey-choose-rubric,
        .survey-choose-student {
            flex: 0 1 calc(50% - 15px);
        }
    }
</style>
